import React, { useState, useEffect,useRef } from "react";
import { useNavigate } from "react-router-dom";
import  ActionCenter  from "./ActionCenter";
import { faBell, faCartShopping,  faHome,  faImage,  faPhone,  faShareNodes, faTrash, faTruck, faUserPlus,faPencilAlt  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt, faArrowRight,faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { X, UserPlus, Loader2,  } from "lucide-react";
import Ola from './images/ola.png'
import Rapido from './images/rapido.png'
import Uber from './images/uber.webp'
import DeliveryProgressBar from './DeliveryProgressBar'; 
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../../Messages/Messages';
import { decryptData } from "../../../utils/storageCrypto";

/* ================= SAMPLE DATA ================= */
const deliveryShipments = [
  {
    supplierName: "Dwaraka Enterprises",
    distance: "4.5 km",
    items: [
      { name: "Item 1", qty: 2, weight: "200 kg" },
      { name: "Item 2", qty: 3, weight: "300 kg" },
    ],
  },
  {
    supplierName: "Krishna Enterprises",
    distance: "2 km",
    items: [
      { name: "Item 3", qty: 1, weight: "150 kg" },
      { name: "Item 4", qty: 2, weight: "250 kg" },
    ],
  },
//   {
//     supplierName: "Ratnagiri Enterprises",
//     distance: "6 km",
//     items: [{ name: "Item 5", qty: 4, weight: "600 kg" }],
//   },
];



const steps = [
  "Confirm Pickups & Dropoffs",
  "Select Delivery mode",
  "Summary",
];

const Meta = ({ label, value }) => (
  <div className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
    <div className="text-[11px] font-medium uppercase tracking-wide text-gray-500">
      {label}
    </div>
    <div className="mt-0.5 text-sm font-semibold text-gray-900">
      {value}
    </div>
  </div>
);


 const FleetSelection = ({ shipmentData, onSelect }) => {
  const isSupplierDelivery = shipmentData?.delivery_type?.toLowerCase() === "supplier";
  const isBrickbucketDelivery = shipmentData?.delivery_type?.toLowerCase() === "brickbucket"
   const isThirdPartyDelivery =shipmentData?.delivery_type?.toLowerCase() === "third_party"; 

  console.log("isBrickbucketDelivery:",isBrickbucketDelivery);
  
  return (
    <div className="px-4 grid grid-cols-3 gap-6">
      <div
        onClick={() => !isSupplierDelivery && onSelect("brickbucket")}
        className={`border rounded-xl p-6 ${
          isSupplierDelivery 
            ? "opacity-50 cursor-not-allowed" 
            : "cursor-pointer hover:border-blue-500 hover:shadow"
        }`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">BrickBucket Fleet</h3>
            <p className="text-sm text-gray-500 mt-2">
              Use your internal delivery fleet for order fulfillment
            </p>
          {isBrickbucketDelivery && (
            <span className="text-green-600 font-bold text-lg">✓</span>
          )}
          </div>
        </div>
      </div>

      <div
        onClick={() => !isSupplierDelivery && onSelect("third_party")}
        className={`border rounded-xl p-6 ${
          isSupplierDelivery 
            ? "opacity-50 cursor-not-allowed" 
            : "cursor-pointer hover:border-blue-500 hover:shadow"
        }`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">Third-Party Logistics</h3>
            <p className="text-sm text-gray-500 mt-2">
              Book deliveries using external logistics partners
            </p>
          </div>
            {isThirdPartyDelivery && (
           <span className="text-green-600 font-bold text-lg">✓</span>
            )}
        </div>
      </div>

      <div
        className={`border rounded-xl p-6 ${
          isSupplierDelivery 
            ? "border-green-500 bg-green-50 cursor-default" 
            : "opacity-50 cursor-not-allowed"
        }`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">Supplier Own Fleet</h3>
            <p className="text-sm text-gray-500 mt-2">
              Delivery handled by supplier's own delivery fleet
            </p>
          </div>
          {isSupplierDelivery && (
            <span className="text-green-600 font-bold text-lg">✓</span>
          )}
        </div>
      </div>
    </div>
  );
}; 

/* const FleetSelection = ({ shipmentData = {}, onSelect }) => {
  const deliveryType = shipmentData?.delivery_type?.toLowerCase();
  const deliveryMode = shipmentData?.delivery_mode?.toLowerCase();

  // 🟢 Normalize state
  const isSupplierDelivery = deliveryType === "supplier";

  const isBrickbucketDelivery =
    deliveryType === "brickbucket" &&
    (deliveryMode === "brickbucket" || !deliveryMode);

  const isThirdPartyDelivery =
    deliveryType === "brickbucket" &&
    deliveryMode === "third_party";

  return (
    <div className="px-4 grid grid-cols-3 gap-6">
      <div
        onClick={() => {
          if (!isSupplierDelivery && !isBrickbucketDelivery) {
            onSelect("brickbucket");
          }
        }}
        className={`border rounded-xl p-6 ${
          isSupplierDelivery
            ? "opacity-50 cursor-not-allowed"
            : isBrickbucketDelivery
            ? "border-green-500 bg-green-50 cursor-default"
            : "cursor-pointer hover:border-blue-500 hover:shadow"
        }`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">BrickBucket Fleet</h3>
            <p className="text-sm text-gray-500 mt-2">
              Use your internal delivery fleet
            </p>
          </div>
          {isBrickbucketDelivery && (
            <span className="text-green-600 font-bold text-lg">✓</span>
          )}
        </div>
      </div>

      <div
        onClick={() => {
          if (!isSupplierDelivery && !isThirdPartyDelivery) {
            onSelect("third_party");
          }
        }}
        className={`border rounded-xl p-6 ${
          isSupplierDelivery
            ? "opacity-50 cursor-not-allowed"
            : isThirdPartyDelivery
            ? "border-green-500 bg-green-50 cursor-default"
            : "cursor-pointer hover:border-blue-500 hover:shadow"
        }`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">Third-Party Logistics</h3>
            <p className="text-sm text-gray-500 mt-2">
              External logistics partners
            </p>
          </div>
          {isThirdPartyDelivery && (
            <span className="text-green-600 font-bold text-lg">✓</span>
          )}
        </div>
      </div>

      <div
        className={`border rounded-xl p-6 ${
          isSupplierDelivery
            ? "border-green-500 bg-green-50 cursor-default"
            : "opacity-50 cursor-not-allowed"
        }`}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold">Supplier Own Fleet</h3>
            <p className="text-sm text-gray-500 mt-2">
              Delivery handled by supplier
            </p>
          </div>
          {isSupplierDelivery && (
            <span className="text-green-600 font-bold text-lg">✓</span>
          )}
        </div>
      </div>
    </div>
  );
}; */


const BrickBucketFleetUI = ({
  partners,
  loading,
  selectedVehicleType,
  setSelectedVehicleType,
  vehicleCategories,
  normalizedPartners, // Add this back for counting
  searchText,        // Add this
  setSearchText ,     // Add this
  onNotify,
  selectedRiders,
  onToggleRider,
  onSelectAll,
  notifiedRiders,
  deliveryCharge,
  setDeliveryCharge,
  setShowItemsPopup,
  setDeliveryChargeError,
  deliveryChargeError,
  items,
updateDeliveryPartner,
 setShowAddPartnerPopup     
}) => {

  return (
    <div className="bg-white rounded-xl border p-6">

      {/* Header */}
      <div className="flex justify-between items-start mb-6">
        <div>
          <h2 className="text-xl font-semibold">Select Vehicle Type & Rides</h2>
          <p className="text-sm text-gray-500">
            Choose a vehicle category to filter the fleet, then assign specific rides to the current delivery manifest.
          </p>
        </div>

       <button
  type="button"
   onClick={() => setShowItemsPopup(true)}
  className="
    inline-flex items-center gap-2
    text-sm font-medium
    border border-gray-300
    rounded-lg
    px-4 py-2
    text-gray-700
    hover:bg-gray-50
    focus:outline-none focus:ring-2 focus:ring-blue-500
  "
>
  <FontAwesomeIcon icon={faCartShopping} className="text-gray-500" />
  <span>Items</span>
  <span className="ml-1 text-xs bg-gray-100 px-2 py-0.5 rounded-full text-gray-600">
 {Array.isArray(items) ? items.length : 0}</span>

</button>

      </div>

      <div className="grid grid-cols-12 gap-6">

        {/* Vehicle Category */}
        <div className="col-span-3 space-y-3">
     
{vehicleCategories.map((type) => {
  // Count partners for THIS vehicle type
  const countForType = normalizedPartners.filter(
    p => p.normalized_vehicle_type === type
  ).length;

  return (
    <VehicleCategory
      key={type}
      label={type}
      available={countForType}
      active={selectedVehicleType === type}
      onClick={() => setSelectedVehicleType(type)}
    />
  );
})}


        </div>

        {/* Available Bikes */}
      <div className="col-span-9 border rounded-xl relative">

          {/* Table Header */}
         <div className="flex justify-between top-0 z-20 items-center pl-4 p-6 border-b">
  <h3 className="font-semibold">
    <div>Available</div>
    <div className="text-sm font-normal">
      {selectedVehicleType}s{" "}
      <span className="text-blue-600">({partners.length})</span>
    </div>
  </h3>

  {/* Delivery Charge Input */}
  <div className="relative">
    <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500">
      ₹
    </span>
    <input
      type="number"
      min="0"
      step="0.01"
      placeholder="Delivery charge"
      value={deliveryCharge === 0 ? 0 : deliveryCharge}
      onChange={(e) => {
        const val = e.target.value;
        if (val === "") {
          setDeliveryCharge("");
        } else {
          setDeliveryCharge(Number(val));
        }
        setDeliveryChargeError("");
      }}
      className="border border-gray-300 rounded-lg pl-7 pr-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
    {deliveryChargeError && (
      <span className="absolute left-0 -bottom-5 text-red-600 text-xs w-max">
        {deliveryChargeError}
      </span>
    )}
  </div>

  {/* Action Buttons Group */}
  <div className="flex items-center gap-3">
    {/* Notify Button */}
    <button
      disabled={selectedRiders.length === 0}
      onClick={() => {
        if (deliveryCharge === "" || Number(deliveryCharge) <= 0) {
          setDeliveryChargeError("Delivery charge is required");
          return;
        }
        onNotify();
      }}
      className={`
        flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all
        ${selectedRiders.length === 0
          ? "bg-gray-300 cursor-not-allowed text-gray-500"
          : "bg-blue-600 hover:bg-blue-700 text-white shadow-md active:scale-95"}
      `}
    >
      Notify <FontAwesomeIcon icon={faBell} />
    </button>

    {/* Create Partner Button */}
    <button
      onClick={() => setShowAddPartnerPopup(true)}
      className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-blue-600 text-white"
    >
      Create Partner
      {/* Create Partner <FontAwesomeIcon icon={faUserPlus} /> */}
    </button>
  </div>

  {/* Search Section */}
  <div className="flex gap-1">
    <div className="relative w-64">
      <svg
        className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 103.75 3.75a7.5 7.5 0 0012.9 12.9z"
        />
      </svg>
      <input
        type="text"
        placeholder="Search by driver name or mobile"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        className="w-full rounded-lg border border-gray-300 bg-white pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
    </div>
  </div>
</div>
          {/* Table */}
          <div className="overflow-y-auto flex-grow relative" style={{ height: '40vh' }}>
          <table className="w-full text-sm">
            <thead className="text-gray-500 border-b sticky z-20 top-0 bg-white">
              <tr>
           <th className="p-3 pl-4 text-left">
  <label className="flex flex-col gap-1">
    {/* LINE 1 – text */}
    <span className="font-medium text-gray-700">
      Select All
    </span>

    {/* LINE 2 – checkbox CENTER */}
    <div className="flex items-center pl-4">
      <input
        type="checkbox"
        checked={
          partners.length > 0 &&
          selectedRiders.length === partners.length
        }
        onChange={(e) => onSelectAll(e.target.checked, partners)}
        className="w-3 h-3"
      />
    </div>
  </label>
</th>

                <th className="p-3 text-left">Driver Details</th>
                <th className="p-3 text-left">Mobile No</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>

    <tbody>
  {loading ? (
    <tr>
      <td colSpan="4" className="text-center py-6 text-gray-500">
        Loading delivery partners...
      </td>
    </tr>
  ) : partners.length === 0 ? (
    <tr>
      <td colSpan="4" className="text-center py-6 text-gray-400">
        No available drivers for this vehicle type
      </td>
    </tr>
  ) : (
    partners.map(driver => {
      const isSelected = selectedRiders.some(r => r.rider_id === driver._id);
      const isNotified = notifiedRiders.some(r => r.rider_id === driver._id);
      
      return (
        <DriverRow
          key={driver._id}
          driver={driver}
          isSelected={isSelected}
          isNotified={isNotified}
          onToggle={onToggleRider}
  updateDeliveryPartner={updateDeliveryPartner}   // ✅ THIS

        />
      );
    })
  )}
</tbody>

          </table>

          <div className="text-center text-xs text-gray-400 py-4">
            No more active bikes available in this zone.
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  



const VehicleCategory = ({
  label,
  available,
  active,
  disabled,
  onClick,
}) => {
  return (
    <div
      onClick={!disabled ? onClick : undefined}
      className={`border rounded-xl p-4 flex justify-between items-center
        ${active ? "border-blue-500 bg-blue-50" : ""}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
      `}
    >
      <div>
        <p className="font-medium">{label}</p>
        <p className="text-xs text-gray-500">{available} Available</p>
      </div>

      {active && (
        <span className="text-blue-600 font-bold">✔</span>
      )}
    </div>
  );
};


const DriverRow = ({
  driver,
  isSelected,
  onToggle,
  isNotified = false ,
updateDeliveryPartner 
}) => {

   const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(driver.name || "");
  const [editMobile, setEditMobile] = useState(driver.mobile || "");

  const handleUpdate = async () => {
    try {
     await updateDeliveryPartner(driver._id, {
  name: editName,
  mobile: editMobile
});
      setIsEditing(false);
    } catch (error) {
    }
  };

 return (
    <tr className="border-b last:border-none">
      <td className="p-3 pl-8">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggle(driver)}
          className={isNotified ? "border-2 border-blue-500" : ""}
        />
      </td>

      <td className="p-3 font-medium">
        {isSelected && isEditing ? (
          <input
            type="text"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
            className="border rounded px-2 py-1 w-32 text-center"
          />
        ) : (
          <>
            {driver.name}
            {isNotified && (
              <span className="ml-2 text-xs px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full">
                Notified
              </span>
            )}
          </>
        )}
      </td>

      <td className="p-3">
        {isSelected && isEditing ? (
          <input
            type="text"
            value={editMobile}
            onChange={(e) => setEditMobile(e.target.value)}
            className="border rounded px-2 py-1 w-32 text-center"
          />
        ) : (
          driver.mobile
        )}
      </td>

       <td className="p-3 text-sm flex items-center justify-between">
        {driver.status || "available"}
        {isSelected && !isNotified && (
          isEditing ? (
            <button
              onClick={handleUpdate}
              className="mr-4 px-2 py-1 bg-blue-600 text-white rounded text-xs hover:bg-blue-700"
            >
              Update
            </button>
          ) : (
            <div
              className="flex items-center mr-4 cursor-pointer text-gray-500 hover:text-blue-600"
              onClick={() => setIsEditing(true)}
            >
              <FontAwesomeIcon icon={faPencilAlt} className="mr-1" />
              Edit
            </div>
          )
        )}
      </td>
    </tr>
  );
};




/* const ThirdPartyLogisticsUI = () => {
  return (
    <div className="px-4 grid grid-cols-3 gap-6 mt-4">

      <LogisticsCard
        title="Uber"
        image= {Uber}
      />

      <LogisticsCard
        title="OLA"
        image={Ola}
      />

      <LogisticsCard
        title="Rapido"
        image={Rapido}
      />

    </div>
  );
}; */


const ShipmentShare = ({ pickups = [], dropoffs = [] }) => {
  console.log("ShipmentShare pickups:", pickups);
  console.log("ShipmentShare dropoffs:", dropoffs);
  const [phone, setPhone] = useState("");

  const buildMessage = () => {
    let message = "🚚 Shipment Route (Open in Rapido)\n\n";

    if (pickups.length) {
      message += "📦 PICKUP POINTS\n";
      pickups.forEach((p, index) => {
        message += `${index + 1}\n`;
        message += `Address: ${p.location.address}\n`;
        message += `Contact: ${p.contact.name} (${p.contact.phone})\n`;
        message += `Open in Rapido:\n`;
        message += `address=${p.location.latitude},${p.location.longitude}\n\n`;
        //message += `intent://maps.google.com/maps?daddr=${p.location.latitude},${p.location.longitude}#Intent;scheme=https;package=com.rapido.passenger;end;\n\n`;
      });
    }

    if (dropoffs.length) {
      message += "📍 DROPOFF POINTS\n";
      dropoffs.forEach((d, index) => {
        message += `${index + 1}\n`;
        message += `Address: ${d.location.address}\n`;
        message += `Contact: ${d.contact.name} (${d.contact.phone})\n`;
        message += `Open in Rapido:\n`;
        message += `address=${d.location.latitude},${d.location.longitude}\n\n`;
        //message += `intent://maps.google.com/maps?daddr=${d.location.latitude},${d.location.longitude}#Intent;scheme=https;package=com.rapido.passenger;end;\n\n`;
      });
    }

    return encodeURIComponent(message);
  };

  const handleShare = () => {
    if (!phone) return;

    const url = `https://wa.me/${phone}?text=${buildMessage()}`;
    window.open(url, "_blank");
  };

  return (
    <div className="px-4 mt-4">
      {/* Pickup + Dropoff Cards */}
      <div className="grid grid-cols-3 gap-6">
        {pickups.map((p, i) => (
          <div key={`p-${i}`} className="border p-4 rounded shadow">
            <h3 className="font-semibold">Pickup</h3>
            <p>{p.contact_name}</p>
            <p>{p.location.address}</p>
            <p>{p.location.latitude}, {p.location.longitude}</p>
          </div>
        ))}

        {dropoffs.map((d, i) => (
          <div key={`d-${i}`} className="border p-4 rounded shadow">
            <h3 className="font-semibold">Dropoff</h3>
            <p>{d.contact_name}</p>
            <p>{d.location.address}</p>
            <p>{d.location.latitude}, {d.location.longitude}</p>
          </div>
        ))}
      </div>

      {/* Share Button */}
      <div className="mt-6 flex gap-3">
        <input
          type="number"
          placeholder="WhatsApp number (91XXXXXXXXXX)"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="border px-3 py-2 rounded w-64"
        />

        <button
          onClick={handleShare}
          disabled={!phone}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 disabled:opacity-50"
        >
          Share Route on WhatsApp
        </button>
      </div>
    </div>
  );
};



const LogisticsCard = ({ title, image, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="border rounded-xl overflow-hidden cursor-pointer hover:shadow-md transition"
    >
      {/* Image Section */}
      <div className="w-full h-36 bg-gray-100 flex items-center justify-center">
        <img
          src={image}
          alt={title}
          className="w-full max-h-full object-contain"
        />
      </div>

      {/* Content Section */}
      <div className="flex items-center justify-between p-4">
        <h3 className="text-lg font-semibold">{title}</h3>
        <span className="text-xl text-gray-400">→</span>
      </div>
    </div>
  );
};



/* ================= STEP UI HELPER ================= */
const renderStepContent = ({
  shipmentData,
  activeStep,
  step2Sequence,
  handleStep2Select,
  activeTab,
  setActiveTab,
  fleetType,
  setFleetType,
  step4Nodes,
  setShowPartnerModal,
  pickups,
  dropoffs,
  partners,
  normalizedPartners,
  partnersLoading,
  selectedVehicleType,
  setSelectedVehicleType,
  getAllDeliveryPartners,
  vehicleCategories,
  searchText,        // Add this
  setSearchText ,
  notifyRiders,
  selectedRiders,
  toggleRider,
  toggleSelectAll,
  notifiedRiders,  // Add this new prop
  shareDeliveryLink,  // Add this line
  isSharing = false,
  deliveryCharge,
  setDeliveryCharge,
  setShowItemsPopup,
  deliveryChargeError,
  setDeliveryChargeError,
  items,
  updateDeliveryPartner,
    setShowAddPartnerPopup
}) => {
  // STEP 2: SUPPLIER RESPONSES
 if (activeStep === 1) {
  return (
    <div className="px-4 mt-6 grid grid-cols-[1fr_auto_1fr] gap-6 items-start">

      {/* ================= LEFT : PICKUPS ================= */}
      <div>
        <div className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-600">
         <FontAwesomeIcon icon={faTruck} className="mr-1"/>
          Pickups ({pickups.length})
        </div>

        <div className="space-y-3">
          {pickups.map((pickup) => {
            const seqIndex = step2Sequence.indexOf(pickup.id);

            return (
             <div
  key={pickup.id}
  onClick={() => handleStep2Select(pickup.id)}
  className="relative cursor-pointer rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition hover:border-blue-500 hover:shadow-md"
>
  {/* Header */}
  <div className="flex items-start justify-between gap-3">
    <div className="min-w-0 flex-1 space-y-1">
      {/* Order Number */}
      <div className="text-sm font-semibold text-gray-900">
        {pickup.orderNo}
      </div>

      {/* Contact Name */}
      {pickup.contact?.name && (
        <div className="flex flex-row text-sm text-gray-700 font-regular">
          {pickup.contact.name}  
        {pickup.contact?.type && (
      <span className="ml-1 font-thin lowercase tracking-wide">
        ({pickup.contact.type})
      </span>
    )}
        </div>
      )}

      {/* Phone */}
      {pickup.contact?.phone && (
        <div className="flex items-center gap-2 text-sm text-blue-600">
          <FontAwesomeIcon icon={faPhone} className="h-3 w-3" />
          <span>{pickup.contact.phone}</span>
        </div>
      )}

      {/* Address */}
      {pickup.location?.address && (
        <div className="flex items-start gap-2 text-xs text-gray-500">
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="mt-0.5 h-3.5 w-3.5 text-gray-400"
          />
          <span className="line-clamp-3">
            {pickup.location.address}
          </span>
        </div>
      )}
    </div>

    {/* Sequence Badge */}
    {seqIndex !== -1 && (
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white">
        {seqIndex + 1}
      </div>
    )}
  </div>

  {/* Footer Meta */}
 <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
  {/* Item thumbnails */}
  <div className="flex items-center gap-2">
    {pickup.item_details?.slice(0, 4).map((item, idx) => (
      <div
        key={idx}
        className="relative h-10 w-10 rounded-md bg-gray-100 flex items-center justify-center overflow-hidden"
      >
        {/* Image or fallback */}
        {item.itemImage ? (
          <img
            src={item.itemImage}
            alt="item"
            className="h-full w-full object-cover"
          />
        ) : (
          <FontAwesomeIcon
            icon={faImage}
            className="text-gray-400 text-lg"
          />
        )}

        {/* Quantity badge */}
        {item.quantity > 0 && (
          <span className="absolute -top-1 -right-1 h-5 min-w-[20px] px-1 rounded-full bg-blue-600 text-white text-[10px] font-bold flex items-center justify-center">
            {item.quantity}
          </span>
        )}
      </div>
    ))}

    {/* +N more */}
    {pickup.item_details?.length > 4 && (
      <div className="h-10 w-10 rounded-md bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-600">
        +{pickup.item_details.length - 4}
      </div>
    )}
  </div>
</div>

</div>

            );
          })}
        </div>
      </div>

      {/* ================= CENTER : FLOW ================= */}
      <div className="flex flex-col items-center pt-10">
        <div className="h-full w-px bg-gray-300 relative">
          <div className="absolute inset-0 flex flex-col justify-around">
            <div className="w-3 h-3 rounded-full bg-gray-400 mx-auto" />
            <div className="w-3 h-3 rounded-full bg-gray-400 mx-auto" />
            <div className="w-3 h-3 rounded-full bg-gray-400 mx-auto" />
          </div>
        </div>
      </div>

      {/* ================= RIGHT : DROPOFFS ================= */}
      <div>
        <div className="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-600">
        <FontAwesomeIcon icon={faHome} className="mr-1" />
          Dropoffs ({dropoffs.length})
        </div>

        <div className="space-y-3">
          {dropoffs.map((dropoff) => {
            const seqIndex = step2Sequence.indexOf(dropoff.id);

            return (
              <div
  key={dropoff.id}
  onClick={() => handleStep2Select(dropoff.id)}
  className="relative cursor-pointer rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition hover:border-blue-500 hover:shadow-md"
>
  {/* Header */}
  <div className="flex items-start justify-between gap-3">
    <div className="min-w-0 flex-1 space-y-1">
      {/* Order Number */}
      <div className="text-sm font-semibold text-gray-900">
        {dropoff.orderNo}
      </div>

      {/* Contact Name */}
      {dropoff.contact?.name && (
        <div className="flex flex-row text-sm font-regular text-gray-700">
          {dropoff.contact.name}
          {dropoff.contact?.type && (
            <span className="ml-1 font-thin lowercase tracking-wide">
              ({dropoff.contact.type})
            </span>
          )}
        </div>
      )}

      {/* Phone */}
      {dropoff.contact?.phone && (
        <div className="flex items-center gap-2 text-sm text-blue-600">
          <FontAwesomeIcon icon={faPhone} className="h-3 w-3" />
          <span>{dropoff.contact.phone}</span>
        </div>
      )}

      {/* Address */}
      {dropoff.location?.address && (
        <div className="flex items-start gap-2 text-sm text-gray-500">
          <FontAwesomeIcon
            icon={faMapMarkerAlt}
            className="mt-0.5 h-3.5 w-3.5 text-gray-400"
          />
          <span className="line-clamp-3">
            {dropoff.location.address}
          </span>
        </div>
      )}
    </div>

    {/* Sequence Badge */}
    {seqIndex !== -1 && (
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white">
        {seqIndex + 1}
      </div>
    )}
  </div>

  {/* Footer Meta (kept identical for layout consistency) */}
  <div className="mt-4 flex items-center justify-between text-xs text-gray-500">
  {/* Item thumbnails */}
  <div className="flex items-center gap-2">
    {dropoff.item_details?.slice(0, 4).map((item, idx) => (
      <div
        key={idx}
        className="relative h-10 w-10 rounded-md bg-gray-100 flex items-center justify-center overflow-hidden"
      >
        {/* Image or fallback */}
        {item.itemImage ? (
          <img
            src={item.itemImage}
            alt="item"
            className="h-full w-full object-cover"
          />
        ) : (
          <FontAwesomeIcon
            icon={faImage}
            className="text-gray-400 text-lg"
          />
        )}

        {/* Quantity badge */}
        {item.quantity > 0 && (
          <span className="absolute -top-1 -right-1 h-5 min-w-[20px] px-1 rounded-full bg-blue-600 text-white text-[10px] font-bold flex items-center justify-center">
            {item.quantity}
          </span>
        )}
      </div>
    ))}

    {/* +N more */}
    {dropoff.item_details?.length > 4 && (
      <div className="h-10 w-10 rounded-md bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-600">
        +{dropoff.item_details.length - 4}
      </div>
    )}
  </div>
</div>
</div>

            );
          })}
        </div>
      </div>
    </div>
  );
}


// STEP 3: DELIVERY SHIPMENTS (YOUR UI)
if (activeStep === 2) {
  const isSupplierDelivery = shipmentData?.delivery_type === "supplier";

  return (
    <div className="w-full">
      {/* Tabs Header */}
      <div className="flex border-b mb-6">
        <button
          className={`px-6 py-3 font-medium ${
            activeTab === "fleet"
              ? "border-b-2 border-blue-600 text-blue-600"
              : "text-gray-500"
          }`}
          onClick={() => setActiveTab("fleet")}
        >
          Select Fleet
        </button>

{/*         <button
          disabled={isSupplierDelivery || !fleetType}  // Disable if supplier delivery
          className={`px-6 py-3 font-medium ${
            activeTab === "partner"
              ? "border-b-2 border-blue-600 text-blue-600"
              : isSupplierDelivery ? "text-gray-300 cursor-not-allowed" : "text-gray-400"
          }`}
          onClick={() => !isSupplierDelivery && fleetType && setActiveTab("partner")}
        >
          Select Delivery Partner
        </button> */}
      </div>

      {/* TAB CONTENT */}
      {activeTab === "fleet" && (
        <FleetSelection
          onSelect={(type) => {
            if (!isSupplierDelivery) {  // Only allow selection if not supplier delivery
              setFleetType(type);
              setActiveTab("partner");
              if (type === "brickbucket") {
                getAllDeliveryPartners();
              }
            }
          }}
          shipmentData={shipmentData}
        />
      )}

      {activeTab === "partner" && fleetType === "brickbucket" && !isSupplierDelivery && (
        <BrickBucketFleetUI
          partners={partners}
          loading={partnersLoading}
          selectedRiders={selectedRiders}
          onToggleRider={toggleRider}
          onSelectAll={toggleSelectAll}
          selectedVehicleType={selectedVehicleType}
          setSelectedVehicleType={setSelectedVehicleType}
          vehicleCategories={vehicleCategories}
          normalizedPartners={normalizedPartners}
          searchText={searchText}
          setSearchText={setSearchText}
          onNotify={notifyRiders}
          notifiedRiders={shipmentData?.notifiedRiders || []}
          setDeliveryCharge={setDeliveryCharge}
          setShowItemsPopup={setShowItemsPopup}
          deliveryCharge={deliveryCharge}
          deliveryChargeError={deliveryChargeError}
           setDeliveryChargeError={setDeliveryChargeError}
         items={items} 
  updateDeliveryPartner={updateDeliveryPartner}
  setShowAddPartnerPopup={setShowAddPartnerPopup}
        />
      )}


{/*       {activeTab === "partner" && fleetType === "third_party" && !isSupplierDelivery && (
        <ThirdPartyLogisticsUI />
      )} */}


      {activeTab === "partner" && fleetType === "third_party" && !isSupplierDelivery && (
        <ShipmentShare
        pickups={pickups}
        dropoffs={dropoffs}
        />
      )}

      {/* Show message if supplier delivery and in partner tab (shouldn't happen) */}
      {activeTab === "partner" && isSupplierDelivery && (
        <div className="text-center py-8 text-gray-500">
          <p className="text-lg font-medium">Supplier Own Fleet</p>
          <p className="mt-2">Delivery is handled by the supplier's own fleet.</p>
          <p className="text-sm mt-1">No delivery partner selection is required.</p>
        </div>
      )}
    </div>
  );
}

  // STEP 4: AWARDED
if (activeStep === 3) {

  return (
    <div className="bg-white mx-1 rounded-xl p-5 space-y-6">

      {/* ================= ROUTE SEQUENCE ================= */}
      <div>
        <div className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-3">
          Route Sequence
        </div>

        <div className="flex items-center gap-3 overflow-x-auto pb-2">
          {step4Nodes.map((node, index) => (
            <div key={node.id} className="flex items-center gap-3 shrink-0">

              {/* ROUTE CARD */}
              <div
                className={`min-w-[240px] rounded-md border p-3
                ${node.type === "pickup"
                  ? "border-green-200 bg-green-50"
                  : "border-indigo-200 bg-indigo-50"}`}
              >
                <div className="flex justify-between items-center mb-1">
                  <span className="text-xs font-semibold text-gray-700">
                    {index + 1}. {node.orderNo}
                  </span>

                  <span
                    className={`text-[10px] px-2 py-0.5 rounded-full font-semibold
                    ${node.type === "pickup"
                      ? "bg-green-600 text-white"
                      : "bg-indigo-600 text-white"}`}
                  >
                    {node.type === "pickup" ? "PICKUP" : "DROPOFF"}
                  </span>
                </div>

                <div className="text-sm font-medium text-gray-900 truncate">
                  {node.type === "pickup" ? node.supplier : node.customer}
                </div>

                <div className="text-xs text-gray-500 mb-2">
                  {node.phone}
                </div>

                <div className="flex gap-3 text-xs text-gray-700">
                  <span><strong>{node.items}</strong> items</span>

                  {node.type === "pickup" && (
                    <>
                      <span>{node.qty} qty</span>
                      <span>{node.weight} kg</span>
                    </>
                  )}

                  {node.type === "dropoff" && (
                    <span>{node.created_at}</span>
                  )}
                </div>
              </div>

              {/* ARROW */}
              {index !== step4Nodes.length - 1 && (
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-gray-300"
                />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* ================= DELIVERY PARTNER ================= */}
     <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
  <div className="flex items-center justify-between mb-4">
    <div className="text-sm font-semibold uppercase tracking-wide text-gray-500">
      Delivery Partner
    </div>

  <span
  className={`text-xs px-2 py-1 rounded-full font-semibold
    ${
      shipmentData?.delivery_partner?.length > 0
        ? "bg-green-100 text-green-700"
        : shipmentData?.notifiedRiders?.length > 0
        ? "bg-yellow-100 text-yellow-700"
        : "bg-gray-100 text-gray-700"
    }`}
>
  {shipmentData?.delivery_partner?.length > 0
    ? "Accepted"
    : shipmentData?.notifiedRiders?.length > 0
    ? "Waiting for acceptance"
    : "Not Assigned"}
</span>

  </div>

{shipmentData?.delivery_partner?.length > 0 ? (
  shipmentData.delivery_partner.map((partner, index) => (
    <div key={index} className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
      <div>
        <div className="text-xs text-gray-500">Partner Name</div>
        <div className="font-semibold text-gray-900">{partner.name || "—"}</div>
      </div>

      <div>
        <div className="text-xs text-gray-500">Mobile</div>
        <div className="font-semibold text-gray-900">{partner.mobile || "—"}</div>
      </div>

      <div>
        <div className="text-xs text-gray-500">Vehicle Number</div>
        <div className="font-semibold text-gray-900">{partner.vehicle_number || "—"}</div>
      </div>

      <div>
        <div className="text-xs text-gray-500">Vehicle Type</div>
        <div className="font-semibold text-gray-900">{partner.vehicle_type || "—"}</div>
      </div>
      
      {/* Show platform and charge if they exist */}
      {partner.platform && (
        <div>
          <div className="text-xs text-gray-500">Platform</div>
          <div className="font-semibold text-gray-900">{partner.platform}</div>
        </div>
      )}
      
      {partner.delivery_charge !== undefined && (
        <div>
          <div className="text-xs text-gray-500">Delivery Charge</div>
          <div className="font-semibold text-gray-900">₹{partner.delivery_charge}</div>
        </div>
      )}
    </div>
  ))
) : (
  <div className="text-center py-4">
    {/* Check if notifiedRiders exists and has items */}
    {shipmentData?.notifiedRiders?.length > 0 ? (
      <>
        <p className="text-xs text-gray-500 mt-1">
          {shipmentData.notifiedRiders.length} rider(s) have been notified but none have accepted yet.
        </p>
        {/* Optionally show notified riders */}
        <div className="mt-3 text-xs">
          <div className="font-medium text-gray-600 mb-1">Notified Riders:</div>
          <div className="flex flex-wrap gap-2 justify-center">
            {shipmentData.notifiedRiders.slice(0, 3).map((rider, idx) => (
              <div key={idx} className="px-2 py-1 bg-gray-100 rounded text-gray-700">
                {rider.name} ({rider.mobile})
              </div>
            ))}
            {shipmentData.notifiedRiders.length > 3 && (
              <div className="px-2 py-1 bg-gray-200 rounded text-gray-600">
                +{shipmentData.notifiedRiders.length - 3} more
              </div>
            )}
          </div>
        </div>
      </>
    ) : (
      <>
        <div className="text-sm font-medium text-gray-600">
          No delivery partner has been notified
        </div>
        <p className="text-xs text-gray-500 mt-1">
          Notify riders in the previous step to assign a delivery partner.
        </p>
      </>
    )}
  </div>
)}

  {/* Show actions only if no partner is assigned */}
   {/* Show actions - Add button always visible, Share only when partner exists */}
<div className="flex justify-end gap-3 mt-5">
  <button
    onClick={() => setShowPartnerModal(true)}
    className="flex items-center gap-2 px-4 py-2 text-sm font-semibold
               rounded-md border border-gray-300 text-gray-700
               hover:bg-gray-100 transition"
  >
    <FontAwesomeIcon icon={faUserPlus} />
    Add
  </button>

  <button
  onClick={shareDeliveryLink}
  disabled={!shipmentData?.delivery_partner?.[0]?.mobile || isSharing}
  className={`flex items-center gap-2 px-4 py-2 text-sm font-semibold
             rounded-md transition
             ${!shipmentData?.delivery_partner?.[0]?.mobile || isSharing
               ? "bg-gray-300 text-gray-500 cursor-not-allowed"
               : "bg-blue-600 text-white hover:bg-blue-700"}`}
>
  <FontAwesomeIcon icon={faShareNodes} />
  {isSharing ? 'Generating...' : 'Share'}
</button>
</div>
</div>

<div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
<DeliveryProgressBar
  pickupsCompleted={shipmentData.progress.pickups.completed}
  pickupsTotal={shipmentData.progress.pickups.total}
  dropoffsCompleted={shipmentData.progress.dropoffs.completed}
  dropoffsTotal={shipmentData.progress.dropoffs.total}
  delivered={shipmentData.progress.delivered}
/>
</div>

    </div>
  );
}
  // DEFAULT (should not hit)
  return null;
};

/* ================= MAIN COMPONENT ================= */
const DeliveryFulfillmentFlow = ({ showAside = true , shipmentId  }) => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(1);
  const [completedSteps, setCompletedSteps] = useState([]);
  const isInitialLoad = useRef(true);
  const [activeTab, setActiveTab] = useState("fleet"); 
const [fleetType, setFleetType] = useState(null); // "brickbucket" | "thirdparty"
const [shipmentData, setShipmentData] = useState(null);
const [pickups, setPickups] = useState([]);
const [dropoffs, setDropoffs] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [coinsToGive, setCoinsToGive] = useState('');
const [crediting, setCrediting] = useState(false);
const [assignPopupOpen, setAssignPopupOpen] = useState(false);
const [assignLoading, setAssignLoading] = useState(false);          
const [suppliers, setSuppliers] = useState([]);                     
const [selectedSuppliers, setSelectedSuppliers] = useState([]); 
const [step2Sequence, setStep2Sequence] = useState([]);
const [expandedItems, setExpandedItems] = useState({});
const [showPartnerModal, setShowPartnerModal] = useState(false);

const [partnerForm, setPartnerForm] = useState({
  name: "",
  mobile: "",
  platform: "",
  vehicle_type: "",
  vehicle_number: "",
  delivery_charge: "",
});

const [platforms, setPlatforms] = useState(["Ola", "Uber", "Rapido"]);
const [showAddPlatform, setShowAddPlatform] = useState(false);
const [newPlatform, setNewPlatform] = useState("");
const [deliveryPartners, setDeliveryPartners] = useState([]);
const [vehicleCategories, setVehicleCategories] = useState([]);
const [partnersLoading, setPartnersLoading] = useState(false);
const [selectedVehicleType, setSelectedVehicleType] = useState("Bike");
const [searchText, setSearchText] = useState("");
const [selectedRiders, setSelectedRiders] = useState([]);
const [saving, setSaving] = useState(false);
const [deliveryShipmentPayload, setDeliveryShipmentPayload] = useState(null);
const [savingPartner, setSavingPartner] = useState(false);
const [showSharePopup, setShowSharePopup] = useState(false);
const [deliveryLink, setDeliveryLink] = useState("");
const [isSharing, setIsSharing] = useState(false);
const [deliveryCharge, setDeliveryCharge] = useState("");
const [showItemsPopup, setShowItemsPopup] = useState(false);
const [deliveryChargeError, setDeliveryChargeError] = useState("");
const [showPopupMessages, setShowPopupMessages] = useState(false);
const [popupMessage, setPopupMessage] = useState('');
const [popupType, setPopupType] = useState('');
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [showPartnerDetailsPopup, setShowPartnerDetailsPopup] = useState(false);
  const [showAddPartnerPopup, setShowAddPartnerPopup] = useState(false);

  const [isStepLoading, setIsStepLoading] = useState(false);
const items =
  shipmentData?.dg_ids?.flatMap(dg =>
    dg.sub_orders?.flatMap(so =>
      so.items?.map(item => ({
        name: item.item_name,
        quantity: item.quantity,
        image: item.item_image
      })) || []
    ) || []
  ) || [];

  useEffect(() => {
    if (shipmentId) {
      getShipmentByID(shipmentId);
    }
  }, [shipmentId]);

  useEffect(() => {
  if (!shipmentData?.dg_ids) return;

  setDeliveryShipmentPayload(prev => ({
    ...prev,
    dg_ids: shipmentData.dg_ids.map(dg => dg._id),
  }));
}, [shipmentData]);

const closePopup = () => {
    setShowPopupMessages(false);
  };
  
  const Retry = async () => {
    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); // Call retry function
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopupMessages(false);
  };
  
  const BackToLoginPage = () => {

    setShowPopupMessages(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };



const canMoveNextFromStep2 = () => {
  return (
    shipmentData?.notifiedRiders?.length > 0 ||
    shipmentData?.delivery_type === "supplier"
  );
};
 

// Add this useEffect to initialize selectedRiders from notifiedRiders
useEffect(() => {
  if (shipmentData?.notifiedRiders?.length > 0) {
    // Transform notifiedRiders to match selectedRiders format
    const initialSelectedRiders = shipmentData.notifiedRiders.map(rider => ({
      rider_id: rider.rider_id,
      name: rider.name,
      mobile: rider.mobile,
      vehicle_type: rider.vehicle_type
    }));
    setSelectedRiders(initialSelectedRiders);
  }
}, [shipmentData]);




useEffect(() => {
  if (!shipmentData) return;

  if (isInitialLoad.current) {
    let step = 1;
    let completed = [];

    if (shipmentData?.notifiedRiders?.length > 0) {
      completed.push(1);
      step = 2;

      setFleetType("brickbucket");
      setActiveTab("partner");

      setSelectedRiders(shipmentData.notifiedRiders);

      // If delivery charge saved in shipmentData
      if (shipmentData.delivery_charge) {
        setDeliveryCharge(shipmentData.delivery_charge);
      }

      // Load partners immediately when notifiedRiders > 0
      getAllDeliveryPartners();
    }
    // ✅ If supplier delivery
   const isAccepted = shipmentData?.delivery_partner?.some(
    partner =>
      partner.status &&
      partner.status.toLowerCase() === "accepted"
  );

  if (isAccepted) {
    completed.push(2);
    step = 3; // Move to Summary
  }

  // Supplier Delivery
  if (shipmentData?.delivery_type === "supplier") {
    completed.push(2);
    completed.push(2);
    step = 3;
    setFleetType("supplier");
  }
  
    setCompletedSteps(completed);
    setActiveStep(step);
    isInitialLoad.current = false;
  }
}, [shipmentData]);


useEffect(() => {
  if (activeStep === 2) {
    setDeliveryShipmentPayload(prev => ({
      ...prev,
      delivery_shipment_Stops: buildShipmentStopsPayload()
    }));
  }
}, [activeStep, step2Sequence]);


useEffect(() => {
  if (
    !shipmentData?.delivery_shipment_Stops ||
    shipmentData.delivery_shipment_Stops.length === 0
  ) return;

  // Sort stops by saved sequence
  const sortedStops = [...shipmentData.delivery_shipment_Stops].sort(
    (a, b) => a.stopSequence - b.stopSequence
  );

  // Rebuild step2Sequence IDs exactly how UI expects
  const restoredSequence = sortedStops.map(stop =>
    `${stop.dg_id}-${stop.stopType}-${stop.order_number}`
  );

  setStep2Sequence(restoredSequence);
}, [shipmentData]);


useEffect(() => {
  setIsStepLoading(true);

  const timer = setTimeout(() => {
    setIsStepLoading(false);
  }, 400);

  return () => clearTimeout(timer);
}, [activeStep]);

const updateDeliveryPartner = async (partnerId, updateData) => {
  try {
    const token = sessionStorage.getItem("token");

    if (!partnerId) {
      throw new Error("Partner ID is required");
    }

    const payload = {
      partner_id: partnerId,
      ...updateData, 
    };

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/update-delivery-partner`,
      {
        method: "PUT", 
        headers: {
          "Content-Type": "application/json",
          "x-token": token || "",
        },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to update delivery partner");
    }

    const result = await response.json();
    setPopupMessage("Delivery partner updated successfully");
    setPopupType("200or201");
     setShowPopupMessages(true);
     setTimeout(() => {
      setShowPopupMessages(false);
    }, 3000); 
    await getAllDeliveryPartners();

    return result;
  } catch (err) {
    console.error("Delivery partner update failed:", err);
     setPopupMessage("Failed to update delivery partner. Please try again.");
     setPopupType("500");
     setShowPopupMessages(true);
    throw err;
  }
};

const getShipmentByID = async (ID) => {
    try {
      // Get user info

      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-shipment/get-delivery-shipment?shipment_id=${ID}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Fetched shipment details:', data);
      setShipmentData(data?.data);
      //setShipmentId(data?.data?._id)

          // Directly normalize the stops from shipmentData
    if (data.data && data.data.delivery_shipment_Stops && data.data.delivery_shipment_Stops.length > 0) {
      const { pickups, dropoffs } = normalizeStopsToPickupsDropoffs(data.data.delivery_shipment_Stops);
      setPickups(pickups);
      setDropoffs(dropoffs);
    }

    // Extract DG IDs and fetch pickups/dropoffs
/*       if (data.data && data.data.dg_ids && data.data.dg_ids.length > 0) {
        fetchPickupsAndDropoffs(data.data.dg_ids);
      } */
    } catch (error) {
      console.error('Error fetching shipment details:', error);
    }
  };

 const fetchPickupsAndDropoffs = async (dgIdsArray) => {
  try {
    const dgIds = dgIdsArray.map(dg => dg._id);
    const dgIdsParam = dgIds.join(',');

    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-shipment/get-pickups-and-dropoffs-for-DGs?dg_ids=${dgIdsParam}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
      }
    );

    if (!response.ok) throw new Error('Network error');
 
    const result = await response.json();
//console.log(result);
    const stops = result?.data?.stops || [];

    const { pickups, dropoffs } = normalizeStopsToPickupsDropoffs(stops);

    setPickups(pickups);
    setDropoffs(dropoffs);


  } catch (error) {
    console.error('Error fetching pickups and dropoffs:', error);
  }
};

const normalizeStopsToPickupsDropoffs = (stops = []) => {
  const pickups = [];
  const dropoffs = [];

  stops.forEach((stop) => {
    const totalQty = stop.items?.reduce(
      (sum, i) => sum + (i.quantity || 0),
      0
    );

    const base = {
      id: `${stop.dg_id}-${stop.stopType}-${stop.order_number}`,
      dg_id: stop.dg_id,
      po_id: stop.po_id || null,
      orderNo: stop.order_number,

      location: {
        address: stop.location?.address || "",
        latitude: stop.location?.latitude || null,
        longitude: stop.location?.longitude || null,
      },

      contact: {
        name: stop.contact?.name,
        phone: stop.contact?.phone,
        type: stop.contact?.type,
      },

      items_details: stop.items || [],
      items: stop.items?.length || 0,
      qty: totalQty,

      packages: stop.packages || { count: 0, weight: 0 },
      otp: stop.otp || null,
      status: stop.status || "PENDING",
      createdAt: stop.createdAt,
    };

    if (stop.stopType === "PICKUP") {
      pickups.push({ ...base, type: "pickup" });
    }

    if (stop.stopType === "DROPOFF") {
      dropoffs.push({ ...base, type: "dropoff" });
    }
  });

  return { pickups, dropoffs };
};

const getAllDeliveryPartners = async () => {
  try {
    setPartnersLoading(true);

const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);
                const encryptedOrganizationId = sessionStorage.getItem('organizationId');
                const organizationId = decryptData(encryptedOrganizationId);

    if (!organizationId) return;

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/get-all-delivery-partners?organizationId=${organizationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token || "",
        },
      }
    );

    if (!response.ok) throw new Error("Failed to fetch delivery partners");

    const result = await response.json();
  console.log(result)
    // ✅ IMPORTANT
    setDeliveryPartners(result?.data?.partners || []);
    setVehicleCategories(
      (result?.data?.vehicle_types || []).map(normalizeVehicleType)
    );

  } catch (err) {
    console.error("Delivery partner fetch failed", err);
  } finally {
    setPartnersLoading(false);
  }
};



const normalizeVehicleType = (type = "") => {
  if (!type || typeof type !== "string") return "";

  return type
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
};


const normalizedPartners = Array.isArray(deliveryPartners)
  ? deliveryPartners.map(p => ({
      ...p,
      normalized_vehicle_type: normalizeVehicleType(p.vehicle_type),
    }))
  : [];


const vehicleFilteredPartners = selectedVehicleType
  ? normalizedPartners.filter(
      p => p.normalized_vehicle_type === selectedVehicleType
    )
  : normalizedPartners;

  const finalPartners = vehicleFilteredPartners.filter(p => {
  const q = searchText.toLowerCase();

  return (
    p.name?.toLowerCase().includes(q) ||
    p.mobile?.includes(q) ||
    p.vehicle_number?.toLowerCase().includes(q)
  );
});

// 🔹 DEFINE FILTERED PARTNERS HERE
// Filter partners based on selected vehicle type AND search text
const filteredPartners = normalizedPartners.filter((partner) => {
  const vehicleMatch = 
    !selectedVehicleType || 
    partner.normalized_vehicle_type === selectedVehicleType;
  
  const searchMatch = 
    !searchText ||
    partner.name?.toLowerCase().includes(searchText.toLowerCase()) ||
    partner.mobile?.includes(searchText) ||
    partner.vehicle_number?.toLowerCase().includes(searchText.toLowerCase());
  
  return vehicleMatch && searchMatch;
});


const toggleItems = (subOrderId) => {
  setExpandedItems(prev => ({
    ...prev,
    [subOrderId]: !prev[subOrderId]
  }));
};

const handleStep2Select = (id) => {
  setStep2Sequence((prev) => {
    if (prev.includes(id)) {
      // ✅ DESELECT → remove & re-sequence
      return prev.filter((x) => x !== id);
    }

    // ✅ SELECT → add at end
    return [...prev, id];
  });
};


// Helper function for step 4
const step4Nodes = step2Sequence
  .map((id) => {
    const pickup = pickups.find((p) => p.id === id);
    if (pickup) return { ...pickup, type: "pickup" };

    const dropoff = dropoffs.find((d) => d.id === id);
    if (dropoff) return { ...dropoff, type: "dropoff" };

    return null;
  })
  .filter(Boolean);

const handleGiveCoins = async () => {
  setCrediting(true);
  // Your API call here
  setTimeout(() => {
    setCrediting(false);
    setShowPopup(false);
  }, 2000);
};


const toggleSupplierSelection = (supplierId) => {
  setSelectedSuppliers(prev => 
    prev.includes(supplierId)
      ? prev.filter(id => id !== supplierId)
      : [...prev, supplierId]
  );
};

// ✅ assignSelectedSuppliers
const assignSelectedSuppliers = async () => {
  setAssignLoading(true);
  // Your API call here
  setTimeout(() => {
    setAssignLoading(false);
    setAssignPopupOpen(false);
  }, 2000);
};

const toggleRider = (driver) => {
  setSelectedRiders(prev => {
    const exists = prev.some(r => r.rider_id === driver._id);

    if (exists) {
      return prev.filter(r => r.rider_id !== driver._id);
    }

    return [
      ...prev,
      {
        rider_id: driver._id,
        name: driver.name,
        mobile: driver.mobile,
        vehicle_type: driver.vehicle_type
      }
    ];
  });
};

const toggleSelectAll = (checked, visiblePartners) => {
  if (!checked) {
    setSelectedRiders([]);
    return;
  }

  const all = visiblePartners.map(p => ({
    rider_id: p._id,
    name: p.name,
    mobile: p.mobile,
    vehicle_type: p.vehicle_type
  }));

  setSelectedRiders(all);
};



const buildShipmentStopsPayload = () => {
  return step2Sequence.map((id, index) => {
    const stop =
      pickups.find(p => p.id === id) ||
      dropoffs.find(d => d.id === id);

    if (!stop) return null;

    return {
      order_number: stop.orderNo,
      stopType: stop.type.toUpperCase(),
      stopSequence: index + 1,

      location: {
        address: stop.location.address,
        latitude: stop.location.latitude,
        longitude: stop.location.longitude,
      },

      contact: {
        name: stop.contact.name,
        phone: stop.contact.phone,
        type: stop.contact.type?.toLowerCase(),
      },

      items: stop.items_details.map(i => ({
        itemId: i.itemId,
        quantity: i.quantity,
      })),

      packages: {
        count: stop.packages?.count || 0,
        weight: stop.packages?.weight || 0,
      },

      otp: stop.otp || null,
      status: stop.status || "PENDING",
      createdAt: stop.createdAt || new Date().toISOString(),
      po_id: stop.po_id || null,
      dg_id: stop.dg_id,
    };
  }).filter(Boolean);
};

const handleNextClick = async () => {
  try {
    setSaving(true);

     if (activeStep === 2 && !canMoveNextFromStep2()) {
      return;
    }

    // For supplier deliveries, use existing stops
    const stopsPayload = shipmentData?.delivery_type === "supplier" 
      ? shipmentData.delivery_shipment_Stops 
      : buildShipmentStopsPayload();

    // Prepare only the changed fields for partial update
    const updatedFields = {
      delivery_shipment_Stops: stopsPayload,
      delivery_mode: shipmentData?.delivery_type === "supplier" ? "supplier" : fleetType || shipmentData?.delivery_mode,
      delivery_type: shipmentData?.delivery_type || deliveryShipmentPayload.delivery_type,
      //estimated_delivery_charge: deliveryCharge || shipmentData?.delivery_charge || 0,
    };

    // Include _id for the API to identify the document
    const finalPayload = {
      _id: shipmentId,
      ...updatedFields,
    };

    await saveDeliveryShipment(finalPayload);
    setCompletedSteps(prev => [...new Set([...prev, activeStep])]);
    setActiveStep(prev => Math.min(prev + 1, steps.length));  } catch (error) {
    console.error(error);
    alert("Failed to update delivery shipment");
  } finally {
    setSaving(false);
  }
};


  const saveDeliveryShipment = async (payload) => {
  const method = payload?._id || payload?.shipment_id ? 'POST' : 'POST';
  const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

  console.log(payload);

  const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-shipment/create-or-update-delivery-shipment`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'x-token' : token,
    },
    body: JSON.stringify(payload),
  });

  const result = await response.json();

  if (!response.ok) {
    throw new Error(result?.message || 'Delivery shipment save failed');
  }

  return result;
};

const notifyRiders = async () => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);


    const payload = {
      shipment_id: shipmentId,
      riders: selectedRiders
    };

    const res = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/create-shipment-rider-assignment`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token || ""
        },
        body: JSON.stringify(payload)
      }
    );

    if (!res.ok) {
      throw new Error("Failed to notify riders");
    }

     setShipmentData(prev => ({
      ...prev,
      notifiedRiders: selectedRiders
    }));

     setPopupMessage("Riders notified successfully");
    setPopupType("200or201");
    setShowPopupMessages(true);
   setTimeout(() => {
      setShowPopupMessages(false);
    }, 3000);
      setShowPartnerDetailsPopup(true);

  } catch (err) {
    console.error(err);
    setPopupMessage("Failed to notify riders. Please try again.");
    setPopupType("500");
    setShowPopupMessages(true);
  }
};

const handleCreatePartner = async () => {
  try {
    setSavingPartner(true);

    // Basic validation
    if (!partnerForm.name || !partnerForm.mobile) {
      setPopupMessage("Please fill in required fields (Name and Mobile)");
      setPopupType("400");
      setShowPopupMessages(true);
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(partnerForm.mobile)) {
      setPopupMessage("Mobile number must be exactly 10 digits");
      setPopupType("400");
      setShowPopupMessages(true);
      return;
    }

    const encryptedOrganizationId = sessionStorage.getItem('organizationId');
    const organizationId = decryptData(encryptedOrganizationId);

    if (!organizationId) {
      setPopupMessage("Organization ID not found. Please log in again.");
      setPopupType("401");
      setShowPopupMessages(true);
      return;
    }

    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    // Prepare the payload with correct types (convert mobile to number if backend expects it)
    const partnerData = {
      name: partnerForm.name,
      mobile: Number(partnerForm.mobile),  // Convert to number for backend schema
      email: partnerForm.email || "",
      // platform: partnerForm.platform || "brickbucket",
      vehicle_type: partnerForm.vehicle_type || "",
      vehicle_number: partnerForm.vehicle_number || "",
      organizationId: organizationId, 
      roleId:3, 
    };

    console.log("Creating partner with payload:", partnerData);

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/create-delivery-partner`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token || "",
        },
        body: JSON.stringify(partnerData),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || "Failed to create delivery partner");
    }

    const result = await response.json();
    setPopupMessage("Delivery partner created successfully");
    setPopupType("200or201");
    setShowPopupMessages(true);
    setTimeout(() => {
      setShowPopupMessages(false);
    }, 3000);
    await getAllDeliveryPartners();

   if (result?.success || result?.data) {
      setShowAddPartnerPopup(false);
      setShowPartnerDetailsPopup(false);  
      setPartnerForm({
        name: "",
        mobile: "",
        email: "",
        // platform: "",
        vehicle_type: "",
        vehicle_number: "",
      });
      setShowAddPlatform(false);
      setNewPlatform("");

      await getAllDeliveryPartners();

      
    }
  } catch (error) {
    console.error("Failed to create partner:", error);
    setPopupMessage("Failed to create delivery partner. Please try again.");
    setPopupType("500");
    setShowPopupMessages(true);
  } finally {
    setSavingPartner(false);
  }
};

// Add this function to your DeliveryFulfillmentFlow component
const acceptRide = async (deliveryPartnerData) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    
    // Format the data to match backend expectations
    const payload = {
      shipmentId: shipmentId,  // Backend expects shipmentId (camelCase)
      user: {
        name: deliveryPartnerData.user.name || '',
        mobile: deliveryPartnerData.user.mobile,
        platform: deliveryPartnerData.user.platform || 'brickbucket',
        vehicle_type: deliveryPartnerData.user.vehicle_type || '',
        vehicle_number: deliveryPartnerData.user.vehicle_number || '',
        _id: deliveryPartnerData.user._id || '', // Backend expects _id for rider_id
        delivery_charge: deliveryPartnerData.delivery_charge
      }
    };

    console.log("Accepting ride with payload:", payload);
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/accept-ride`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to accept ride');
    }

    const result = await response.json();
    console.log('Ride accepted successfully:', result);
    
    return result;
  } catch (error) {
    console.error('Error accepting ride:', error);
    throw error;
  }
};


const handleSavePartner = async () => {
  try {
    setSavingPartner(true);

    if (!partnerForm.name || !partnerForm.mobile) {
      alert("Please fill in required fields (Name and Mobile)");
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(partnerForm.mobile)) {
      alert("Mobile number must be exactly 10 digits");
      return;
    }

    const payload = {
      shipmentId: shipmentId,
      mobile: partnerForm.mobile,
      user: {
        name: partnerForm.name,
        mobile: partnerForm.mobile,
        platform: partnerForm.platform || "brickbucket",
        vehicle_type: partnerForm.vehicle_type || "",
        vehicle_number: partnerForm.vehicle_number || "",
        delivery_charge: partnerForm.delivery_charge || shipmentData.estimated_delivery_charge
      },
    };


    console.log("Accepting ride with payload:", payload);

    const result = await acceptRide(payload);

    if (result?.success) {
      const newPartner = {
        name: partnerForm.name,
        mobile: partnerForm.mobile,
        platform: partnerForm.platform || "brickbucket",
        vehicle_type: partnerForm.vehicle_type || "",
        vehicle_number: partnerForm.vehicle_number || "",
        delivery_charge: partnerForm.delivery_charge || shipmentData.estimated_delivery_charge,
      };

      setShipmentData(prev => ({
        ...prev,
        delivery_partner: [newPartner],
      }));

      setShowPartnerModal(false);
      
setPopupMessage("Delivery partner has been successfully assigned!");
setPopupType("200or201");
setShowPopupMessages(true);

setTimeout(() => {
  setShowPopupMessages(false);
}, 3000);
    }
  } catch (error) {
    console.error("Failed to save partner:", error);
    alert(error.message || "Failed to assign delivery partner");
  } finally {
    setSavingPartner(false);
  }
};

// Add this function to your DeliveryFulfillmentFlow component
const shareDeliveryLink = async () => {
  try {
    setIsSharing(true);
    
    // Check if we have the required data
    if (!shipmentData?.delivery_partner?.[0]?.mobile) {
      alert("No delivery partner mobile number found");
      setIsSharing(false);
      return;
    }

    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    
    const payload = {
      delivery_type: shipmentData?.delivery_type || "brickbucket",
      mobile: shipmentData.delivery_partner[0].mobile
    };

    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}delivery-partner/share-delivery-link`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token || '',
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Failed to share delivery link');
    }

    const result = await response.json();
    console.log('Delivery link shared successfully:', result);
    
    if (result.status === 200 && result.data) {
      setDeliveryLink(result.data);
      setShowSharePopup(true);
    } else {
      alert('Failed to generate Delivery link!');
    }
    
    return result;
  } catch (error) {
    console.error('Error sharing delivery link:', error);
    alert(error.message || 'Failed to share delivery link. Please try again.');
    throw error;
  } finally {
    setIsSharing(false);
  }
};

// Helper functions for the share popup
const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(deliveryLink);
    alert('Link copied to clipboard!');
  } catch (err) {
    console.error('Failed to copy:', err);
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = deliveryLink;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    alert('Link copied to clipboard!');
  }
};

const openDeliveryLink = () => {
  window.open(deliveryLink, '_blank', 'noopener,noreferrer');
};

const shareViaNative = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: 'Delivery Link',
        text: 'Here is the delivery link:',
        url: deliveryLink,
      });
    } catch (err) {
      console.error('Error sharing:', err);
    }
  } else {
    // Fallback to copying to clipboard
    copyToClipboard();
    alert('Link copied! You can now share it manually.');
  }
};

  return (
/*     <div className="p-6 bg-gray-100 min-h-screen flex flex-col">
 */   
<div className="flex h-screen w-full overflow-hidden bg-white">
<div className="relative flex-1 h-full flex flex-col min-w-0"> 
<div className="flex-1 overflow-y-auto pb-24">        
        
        <div className=" sticky top-0 z-30 borderborder-gray-200  shadow-sm rounded-md px-2 py-2 pb-4  bg-gray-50">
         {/* GRAY CONNECTOR LINE */}
  <div
    className="absolute top-6 h-[2px] bg-gray-300 z-0"
    style={{
      left: `${50 / steps.length}%`,
      right: `${50 / steps.length}%`,
      width:
        steps.length > 1
          ? `calc(100% - ${100 / steps.length}%)`
          : "0%",
    }}
  />

  {/* BLUE PROGRESS LINE – FIXED */}
  <div
    className="absolute top-6 h-[2px] bg-green-500 z-10 transition-all duration-500 ease-in-out"
    style={{
      left: `${50 / steps.length}%`,
      width:
        activeStep <= 1
          ? "0%"
          : `calc(
              ((100% - ${100 / steps.length}%)
              / ${steps.length - 1})
              * ${activeStep - 1}
            )`,
    }}
  />

  {/* STEPS */}
  <div className="flex justify-between relative z-20">
    {steps.map((label, index) => {
      const step = index + 1;
      const isCompleted = step < activeStep;
      const isActive = step === activeStep;

      return (
        <div
          key={label}
         onClick={() => {
  // Only allow moving to NEXT step
  const isNextStep = step === activeStep + 1;

  if (!isNextStep) return;

  // Apply SAME validation as Next button
  if (activeStep === 2 && !canMoveNextFromStep2()) return;

  setActiveStep(step);
}}
          className={`flex flex-col items-center cursor-pointer flex-1 ${
            step === 1 ? "-ml-6" : step === steps.length ? "ml-6" : ""
          }`}
        >
          {/* Circle */}
          <div
            className={`w-12 h-12 rounded-full flex items-center justify-center shadow-md border-2 transition-all duration-300 ${
              isCompleted
                ? "bg-green-500 border-green-500 scale-110"
                : isActive
                ? "bg-white border-blue-700 shadow-lg scale-105"
                : "bg-white border-gray-300 hover:border-gray-400"
            }`}
          >
            {isCompleted ? (
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <span
                className={`font-bold text-sm ${
                  isActive ? "text-blue-600" : "text-gray-400"
                }`}
              >
                {step}
              </span>
            )}
          </div>

          {/* Label */}
          <p
            className={`mt-2 text-xs font-medium text-center transition-colors duration-300 ${
               isCompleted
  ? "text-green-600 font-semibold"
  : isActive
  ? "text-blue-600 font-semibold"
  : "text-gray-400"
            }`}
          >
            {label}
          </p>
        </div>
      );
    })}
  </div>
 
        </div>

        {/* ================= STEP CONTENT (SINGLE CALL) ================= */}
{isStepLoading ? (
   <div className=" flex w-full  justify-center  bg-opacity-50 ">
    <div className=" flex space-x-2 w-full justify-center items-center h-20  ">
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
      <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
    </div>
  </div>
) : (
        
  renderStepContent({
  shipmentData,
 activeStep,
  step2Sequence,
  handleStep2Select,
  activeTab,
  setActiveTab,
  fleetType,
  setFleetType,
  step4Nodes,
  setShowPartnerModal,
  pickups,
  dropoffs,
  partners: filteredPartners,  // Changed from finalPartners to filteredPartners
  normalizedPartners,
  partnersLoading,
  selectedVehicleType,
  setSelectedVehicleType,
  getAllDeliveryPartners,
  vehicleCategories,
  searchText,
  setSearchText,
  notifyRiders,
  selectedRiders,  // This should now include notified riders
  toggleRider,
  toggleSelectAll,
  notifiedRiders: shipmentData?.notifiedRiders || [],  // Add this
  shareDeliveryLink: shareDeliveryLink,  // Add this 
  isSharing: isSharing,
  deliveryCharge,
  setDeliveryCharge,
  showItemsPopup,
  setShowItemsPopup,
  deliveryChargeError,
  setDeliveryChargeError,
 items: items,
 updateDeliveryPartner: updateDeliveryPartner,
 setShowAddPartnerPopup: setShowAddPartnerPopup

 })
)}

      
</div>
{activeStep !== 3 && (
<div className="sticky bottom-0 left-0 right-0 z-[10] h-28 bg-white border-t border-gray-200 p-4 shadow-[0_-10px_15px_-3px_rgba(0,0,0,0.1)]">
  <div className="flex justify-end px-6 max-w-7xl mx-auto">
  <button
    disabled={saving || !shipmentId}
    onClick={handleNextClick}
    className={`${
      saving ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
    } text-white font-bold py-1 px-4 rounded-lg shadow-xl w-auto`}
  >
    {saving ? 'Saving...' : 'Next'}
  </button>
        </div>
      </div>
)}
      </div>
{showAside && (
      <aside className="sticky top-[10px] h-[calc(100vh-73px)] w-[20%] border-l p-6">
          <ActionCenter />
        </aside> 

)}
       {showPopup && (
         <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
           <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
             {/* Header */}
             <div className="flex justify-between items-center mb-4">
               <h4 className="font-semibold text-lg">Give BuildCoins</h4>
               <button
                 onClick={() => setShowPopup(false)}
                 className="text-gray-500 hover:text-gray-800"
               >
                 <X size={20} />
               </button>
             </div>
       
             {/* Input Field */}
             <div className="mb-4">
               <label className="block text-sm font-medium text-gray-700 mb-1">
                 Enter BuildCoins
               </label>
               <input
                 type="number"
                 min="0"
                 value={coinsToGive}
                 onChange={(e) => setCoinsToGive(e.target.value)}
                 className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                 placeholder="0"
               />
             </div>
       
             {/* Confirm Button */}
             <button
               type="button"
               className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow w-full disabled:opacity-50"
               onClick={handleGiveCoins}
               disabled={crediting || !coinsToGive}
             >
               {crediting ? 'Giving...' : 'Give'}
             </button>
           </div>
         </div>
       )}
      
{assignPopupOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white w-full max-w-lg p-6 rounded-xl shadow-xl relative">

      <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
        <UserPlus className="mr-2 text-blue-600" size={20} />
        Assign Suppliers
      </h3>

      <p className="text-sm text-gray-600 mb-4">
        Select suppliers who can supply the items in this RFQ.
      </p>

      {/* Supplier List */}
      <div className="max-h-60 overflow-y-auto border rounded-lg p-3 bg-gray-50">
        {assignLoading ? (
          <div className="text-center py-6 text-gray-500">
            <Loader2 className="animate-spin mx-auto mb-2" />
            Loading suppliers...
          </div>
        ) : suppliers.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No available suppliers found</p>
        ) : (
          suppliers.map((s, idx) => (
            <label key={idx} className="flex items-center p-2 border-b cursor-pointer">
              <input
                type="checkbox"
                value={s.vendor_id}
                onChange={(e) => toggleSupplierSelection(e.target.value)}
                className="mr-3"
              />
              <div>
                <p className="font-medium">{s.vendor_details.company_name}</p>
                <p className="text-xs text-gray-600">
                  {s.items_count} items | {s.vendor_details.mobile_number}
                </p>
              </div>
            </label>
          ))
        )}
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-2 mt-5">
        <button
          className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
          onClick={() => setAssignPopupOpen(false)}
        >
          Close
        </button>

        <button
  onClick={() => selectedSuppliers.length > 0 && assignSelectedSuppliers()}
  className={`
    px-3 py-1 rounded text-white 
    ${selectedSuppliers.length === 0 
      ? "bg-gray-400 cursor-not-allowed" 
      : "bg-blue-600 hover:bg-blue-700 cursor-pointer"}
  `}
>
  Assign
</button>

      </div>
    </div>
  </div>
)}

{/*  Add / edit details of delivery partner  */}
{showPartnerModal && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[999] p-4">
    <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl p-6">

      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Add Delivery Partner</h3>
        <button onClick={() => setShowPartnerModal(false)}>
          <X size={20} />
        </button>
      </div>

      {/* Form */}
      <div className="grid grid-cols-2 gap-4">

        <input
          placeholder="Name"
          value={partnerForm.name}
          onChange={(e) =>
            setPartnerForm({ ...partnerForm, name: e.target.value })
          }
          className="border rounded-lg px-3 py-2"
        />

       <input
  placeholder="10-digit mobile number"
  value={partnerForm.mobile}
  onChange={(e) => {
    const value = e.target.value;
    // Remove any non-numeric characters
    const numericValue = value.replace(/\D/g, '');
    // Limit to 10 digits
    if (numericValue.length <= 10) {
      setPartnerForm({ ...partnerForm, mobile: numericValue });
    }
  }}
  maxLength="10"
  className="border rounded-lg px-3 py-2"
/>

        {/* Platform Selector */}
        <div className="col-span-2">
          <p className="text-sm font-medium mb-2">Platform</p>

          <div className="flex flex-wrap gap-2 mb-2">
            {platforms.map((p) => (
              <button
                key={p}
                type="button"
                onClick={() =>
                  setPartnerForm({ ...partnerForm, platform: p })
                }
                className={`px-3 py-1 rounded-full border text-sm
                  ${
                    partnerForm.platform === p
                      ? "bg-blue-600 text-white border-blue-600"
                      : "border-gray-300 text-gray-700"
                  }`}
              >
                {p}
              </button>
            ))}

            <button
              type="button"
              onClick={() => setShowAddPlatform(true)}
              className="px-3 py-1 rounded-full border border-dashed text-sm text-gray-600"
            >
              + Add
            </button>
          </div>

          {showAddPlatform && (
            <div className="flex gap-2">
              <input
                placeholder="Platform name"
                value={newPlatform}
                onChange={(e) => setNewPlatform(e.target.value)}
                className="flex-1 border rounded-lg px-3 py-2"
              />
              <button
                type="button"
                onClick={() => {
                  if (!newPlatform.trim()) return;
                  setPlatforms([...platforms, newPlatform]);
                  setPartnerForm({
                    ...partnerForm,
                    platform: newPlatform,
                  });
                  setNewPlatform("");
                  setShowAddPlatform(false);
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg"
              >
                Add
              </button>
            </div>
          )}
        </div>

        <input
          placeholder="Vehicle Type"
          value={partnerForm.vehicle_type}
          onChange={(e) =>
            setPartnerForm({ ...partnerForm, vehicle_type: e.target.value })
          }
          className="border rounded-lg px-3 py-2"
        />

        <input
          placeholder="Vehicle Number"
          value={partnerForm.vehicle_number}
          onChange={(e) =>
            setPartnerForm({ ...partnerForm, vehicle_number: e.target.value })
          }
          className="border rounded-lg px-3 py-2"
        />

        <input
          type="number"
          placeholder="Delivery Charge"
          value={partnerForm.delivery_charge}
          onChange={(e) =>
            setPartnerForm({
              ...partnerForm,
              delivery_charge: e.target.value,
            })
          }
          className="border rounded-lg px-3 py-2 col-span-2"
        />
      </div>

      {/* Footer */}
      {/* In your modal's footer section */}
<div className="flex justify-end gap-3 mt-6">
  <button
    onClick={() => setShowPartnerModal(false)}
    className="px-4 py-2 border rounded-lg hover:bg-gray-50"
  >
    Cancel
  </button>

 <button
  onClick={handleSavePartner}
  disabled={savingPartner}
  className={`px-4 py-2 bg-blue-600 text-white rounded-lg ${
    savingPartner ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'
  }`}
>
  {savingPartner ? 'Saving...' : 'Save & Assign'}
</button>
</div>
    </div>
  </div>
)}

{/* Share Delivery Link Popup */}
{showSharePopup && (
  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-md rounded-xl shadow-2xl p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">Share Delivery Link</h3>
        <button
          onClick={() => setShowSharePopup(false)}
          className="text-gray-500 hover:text-gray-800"
        >
          <X size={20} />
        </button>
      </div>

      {/* Link Display */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Delivery Link
        </label>
        <div className="flex items-center gap-2">
          <div className="flex-1 border border-gray-300 rounded-lg px-3 py-2 bg-gray-50 break-all text-sm">
            {deliveryLink}
          </div>
          <button
            onClick={copyToClipboard}
            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg"
            title="Copy to clipboard"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
          </button>
        </div>
      </div>

      {/* Share via WhatsApp */}
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h4 className="text-sm font-medium text-gray-700 mb-3">Share with Delivery Partner</h4>
        <div className="space-y-3">
          <button
            onClick={() => {
              if (shipmentData?.delivery_partner?.[0]?.mobile) {
                // Format the mobile number (remove any non-digit characters)
                const mobileNumber = shipmentData.delivery_partner[0].mobile.replace(/\D/g, '');
                // Create WhatsApp URL with message
                const whatsappUrl = `https://wa.me/${mobileNumber}?text=${encodeURIComponent(`Delivery Link: ${deliveryLink}`)}`;
                window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
              }
            }}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-green-500 text-white rounded-lg hover:bg-green-600"
            disabled={!shipmentData?.delivery_partner?.[0]?.mobile}
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.76.982.998-3.675-.236-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.9 6.994c-.004 5.45-4.438 9.88-9.888 9.88m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.333.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.333 11.893-11.893 0-3.18-1.24-6.162-3.495-8.411" />
            </svg>
            <span className="font-medium">Share via WhatsApp</span>
          </button>
          
          <p className="text-xs text-gray-500 text-center">
            This will open WhatsApp chat of delivery partner ({shipmentData?.delivery_partner?.[0]?.mobile || 'No mobile number'})
          </p>
        </div>
      </div>  
    </div>
  </div>
)}

{showItemsPopup && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-4xl rounded-xl shadow-xl">

      {/* Header */}
      <div className="flex justify-between items-center px-6 py-4 border-b">
        <h3 className="text-lg font-semibold">
          Item Details 
        </h3>

        <button
          onClick={() => setShowItemsPopup(false)}
          className="text-gray-500 hover:text-gray-800 text-xl"
        >
          ✕
        </button>
      </div>

      {/* Table */}
      <div className="p-6 overflow-x-auto">
        <table className="w-full text-sm border">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="p-3 text-left">Item Image</th>
              <th className="p-3 text-left">Item Name</th>
              <th className="p-3 text-center">Quantity</th>
            </tr>
          </thead>

          <tbody>
            {(!items || items.length === 0) ? (
              <tr>
                <td colSpan="4" className="text-center py-6 text-gray-500">
                  No items available
                </td>
              </tr>
            ) : (
              items.map((item, index) => (
                <tr key={index} className="border-b last:border-none">

                  {/* Image */}
                <td className="p-3">
  <div className="w-12 h-12 rounded border bg-gray-50 flex items-center justify-center overflow-hidden">
    {console.log("Rendering item image for:", `${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image}`)}
    {item.image ? (
      <img
        src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${item.image}`}
        alt={item.name}
        className="w-full h-full object-cover"
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
    ) : (
      <span className="inline-flex w-full h-full bg-gray-100 items-center justify-center text-[10px] text-gray-400 text-center leading-tight">
        No<br />Image
      </span>
    )}
  </div>
</td>


                  {/* Name */}
                  <td className="p-3 font-medium text-gray-800">
                    {item.name || "N/A"}
                  </td>

                  {/* Quantity */}
                  <td className="p-3 text-center">
                    {item.quantity || 0}
                  </td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  </div>
)}

{showPartnerDetailsPopup && (
  <div className="fixed inset-0 bg-black/40 backdrop-blur-md flex justify-center items-center z-50 p-4">
    <div className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden">

      {/* Header */}
      <div className="flex justify-between items-center px-6 py-4 border-b bg-gradient-to-r from-gray-50 to-white">
        <div>
          <h3 className="text-xl font-semibold text-gray-800">
            Delivery Partner Details
          </h3>
          <p className="text-xs text-gray-500 mt-1">
            View assigned or notified delivery partners
          </p>
        </div>

        <button
          onClick={() => setShowPartnerDetailsPopup(false)}
          className="p-2 rounded-full hover:bg-gray-100 transition"
        >
          <X size={20} className="text-gray-500" />
        </button>
      </div>

      {/* Body */}
      <div className="p-6 bg-gray-50">

        {/* Status Badge */}
        <div className="flex justify-between items-center mb-6">
          <div className="text-sm font-semibold uppercase tracking-wide text-gray-500">
         Partner Response Status
          </div>

          <span
            className={`text-xs px-3 py-1.5 rounded-full font-semibold shadow-sm
              ${
                shipmentData?.delivery_partner?.length > 0
                  ? "bg-green-100 text-green-700"
                  : shipmentData?.notifiedRiders?.length > 0
                  ? "bg-yellow-100 text-yellow-700"
                  : "bg-gray-200 text-gray-600"
              }`}
          >
            {shipmentData?.delivery_partner?.length > 0
              ? "Accepted"
              : shipmentData?.notifiedRiders?.length > 0
              ? "Waiting for acceptance"
              : "Not Assigned"}
          </span>
        </div>

        {/* Assigned Partner Section */}
        {shipmentData?.delivery_partner?.length > 0 ? (
          shipmentData.delivery_partner.map((partner, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 mb-4"
            >
              <div className="grid grid-cols-2 md:grid-cols-3 gap-5 text-sm">

                <div>
                  <div className="text-xs text-gray-400 mb-1">Partner Name</div>
                  <div className="font-semibold text-gray-900">
                    {partner.name || "—"}
                  </div>
                </div>

                <div>
                  <div className="text-xs text-gray-400 mb-1">Mobile</div>
                  <div className="font-semibold text-gray-900">
                    {partner.mobile || "—"}
                  </div>
                </div>

                <div>
                  <div className="text-xs text-gray-400 mb-1">Vehicle Number</div>
                  <div className="font-semibold text-gray-900">
                    {partner.vehicle_number || "—"}
                  </div>
                </div>

                <div>
                  <div className="text-xs text-gray-400 mb-1">Vehicle Type</div>
                  <div className="font-semibold text-gray-900">
                    {partner.vehicle_type || "—"}
                  </div>
                </div>

                {partner.platform && (
                  <div>
                    <div className="text-xs text-gray-400 mb-1">Platform</div>
                    <div className="font-semibold text-gray-900">
                      {partner.platform}
                    </div>
                  </div>
                )}

                {partner.delivery_charge !== undefined && (
                  <div>
                    <div className="text-xs text-gray-400 mb-1">Delivery Charge</div>
                    <div className="font-semibold text-green-600">
                      ₹{partner.delivery_charge}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 text-center">

            {shipmentData?.notifiedRiders?.length > 0 ? (
              <>
                <div className="text-sm font-semibold text-gray-700">
                  Waiting for rider acceptance
                </div>

                <p className="text-xs text-gray-500 mt-2">
                  {shipmentData.notifiedRiders.length} rider(s) notified.
                </p>

                <div className="mt-4 flex flex-wrap gap-2 justify-center">
                  {shipmentData.notifiedRiders.slice(0, 3).map((rider, idx) => (
                    <div
                      key={idx}
                      className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium"
                    >
                      {rider.name} ({rider.mobile})
                    </div>
                  ))}

                  {shipmentData.notifiedRiders.length > 3 && (
                    <div className="px-3 py-1 bg-gray-200 rounded-full text-xs text-gray-600">
                      +{shipmentData.notifiedRiders.length - 3} more
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="text-sm font-semibold text-gray-700">
                  No delivery partner assigned
                </div>
                <p className="text-xs text-gray-500 mt-2">
                  Notify riders to assign a delivery partner.
                </p>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  </div>
)}

{showAddPartnerPopup && (
  <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[999] p-4 transition-all">
    <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden border border-slate-100 max-h-[90vh] overflow-y-auto">
      
      {/* Header Section */}
      <div className="px-6 py-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
        <div>
          <h3 className="text-xl font-bold text-slate-800">New Delivery Partner</h3>
          <p className="text-xs text-slate-500 mt-1">Register a new driver to your network</p>
        </div>
        <button 
          onClick={() => setShowAddPartnerPopup(false)}
          className="p-2 hover:bg-slate-200 rounded-full transition-colors text-slate-400"
        >
          <X size={20} />
        </button>
      </div>

      {/* Form Body */}
      <div className="p-5 space-y-4">
        
        {/* Basic Info Group */}
        <div className="space-y-3">
          {/* Full Name - full width */}
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-slate-700 ml-1">Full Name</label>
            <input
              placeholder="e.g. John Doe"
              value={partnerForm.name}
              onChange={(e) => setPartnerForm({ ...partnerForm, name: e.target.value })}
              className="w-full border border-slate-200 rounded-xl px-4 py-2 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-sm"
            />
          </div>

          {/* Mobile and Email - same line */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <label className="text-sm font-semibold text-slate-700 ml-1">Mobile Number</label>
              <input
                placeholder="10-digit mobile number"
                value={partnerForm.mobile}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                  setPartnerForm({ ...partnerForm, mobile: numericValue });
                }}
                className="w-full border border-slate-200 rounded-xl px-4 py-2 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-sm"
              />
            </div>

            <div className="space-y-1.5">
              <label className="text-sm font-semibold text-slate-700 ml-1">Email</label>
              <input
                type="email"
                placeholder="e.g. john@example.com"
                value={partnerForm.email || ""}
                onChange={(e) => setPartnerForm({ ...partnerForm, email: e.target.value })}
                className="w-full border border-slate-200 rounded-xl px-4 py-2 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-sm"
              />
            </div>
          </div>
        </div>

        {/* Vehicle Info Group */}
        <div className="grid grid-cols-2 gap-4 pt-2">
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-slate-700 ml-1">Vehicle Type</label>
            <input
              placeholder="e.g. Bike"
              value={partnerForm.vehicle_type}
              onChange={(e) => setPartnerForm({ ...partnerForm, vehicle_type: e.target.value })}
              className="w-full border border-slate-200 rounded-xl px-4 py-2 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all placeholder:text-sm"
            />
          </div>
          <div className="space-y-1.5">
            <label className="text-sm font-semibold text-slate-700 ml-1">Vehicle Number</label>
            <input
              placeholder="e.g. AB 01 CD 1234"
              value={partnerForm.vehicle_number}
              onChange={(e) => setPartnerForm({ ...partnerForm, vehicle_number: e.target.value })}
              className="w-full border border-slate-200 rounded-xl px-4 py-2 focus:ring-1  focus:ring-blue-500 focus:border-blue-500 outline-none transition-all  placeholder:text-sm"
            />
          </div>
        </div>
      </div>

      {/* Footer Actions */}
      <div className="px-6 py-2 bg-slate-50 border-t border-slate-100 flex justify-end gap-3 text-sm">
        <button
          onClick={() => setShowAddPartnerPopup(false)}
          className="px-4 py-2 text-slate-600 font-semibold border border-slate-300 bg-slate-100 hover:bg-slate-200 transition-colors rounded-lg"
        >
          Cancel
        </button>
        <button
          onClick={handleCreatePartner}
          disabled={savingPartner}
          className="px-4 py-2 bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-200 hover:bg-blue-700 active:scale-95 disabled:opacity-50 disabled:active:scale-100 transition-all"
        >
          {savingPartner ? 'Creating...' : 'Save Partner'}
        </button>
      </div>
    </div>
  </div>
)}

  {showPopupMessages && (
  <div className=" z-[999]">
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
    
    </div>
  );
};

export default DeliveryFulfillmentFlow;
